import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const CTASection = () => {
  const [content, setContent] = useState({
    title: "Join Us in Honoring Leonard's Memory",
    description: "Your support helps us celebrate Leonard Nimoy's inspiring legacy and share his message of hope with the world.",
    buttonText: "Make a Donation",
    buttonLink: "/donate"
  });

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/homepage-content`);
        if (response.data) {
          setContent({
            title: response.data.cta_title || content.title,
            description: response.data.cta_description || content.description,
            buttonText: response.data.cta_button_text || content.buttonText,
            buttonLink: response.data.cta_button_link || content.buttonLink
          });
        }
      } catch (err) {
        console.log('Using default CTA content');
      }
    };
    fetchContent();
  }, []);

  return (
    <section className="py-24 bg-[#0a0a0b]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="w-16 h-16 bg-amber-500/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <Heart className="w-8 h-8 text-amber-500" />
        </div>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
          {content.title}
        </h2>
        <p className="text-gray-400 text-lg mb-8 max-w-2xl mx-auto">
          {content.description}
        </p>
        <Link
          to={content.buttonLink}
          className="inline-flex items-center justify-center px-8 py-3 bg-amber-500 hover:bg-amber-600 text-black font-semibold rounded-full transition-all hover:scale-105"
        >
          {content.buttonText}
        </Link>
      </div>
    </section>
  );
};

export default CTASection;
